import { useEffect, useReducer, useRef } from 'react';

// REDUX
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getConfigurationDataLoadedState, getHttpError, getPendingRequestData, setReconnectNotification, userAction } from '@Managers/Redux/HttpState';

//TYPES
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { IUseErrorManagerDefaults, IUseErrorManagerState } from './UseErrorManager.types';

export const UseErrorManager = (): void => {
    const dispatch = useAppDispatch();
    const pendingData = useAppSelector(getPendingRequestData);
    const httpError = useAppSelector(getHttpError);
    const configurationDataLoaded = useAppSelector(getConfigurationDataLoadedState);

    const pendingDataRef = useRef(pendingData);
    pendingDataRef.current = pendingData;

    let timeOutId: any;

    const [state, setState] = useReducer(
        (state: IUseErrorManagerState, newState: Partial<IUseErrorManagerState>) => ({ ...state, ...newState }),
        IUseErrorManagerDefaults
    );

    useEffect(() => {
        if (configurationDataLoaded) {
            const config = ConfigLoader.getConfiguration(EConfigurationNames.CONNECTION)?.connectionConfiguration;
            setState({ maxTries: config.reconnectOptions.retries, retryTimeout: config.reconnectOptions.retryTimeout });
        }
    }, [configurationDataLoaded]);

    useEffect(() => {
        if (pendingData && httpError && httpError.networkError && state.tryAttepmt < state.maxTries) {
            clearTimeout(timeOutId);

            const tryAttepmt = state.tryAttepmt + 1;
            setState({ tryAttepmt: tryAttepmt });
            dispatch(setReconnectNotification({ active: true, tryAttepmt: tryAttepmt, maxTries: state.maxTries }));

            timeOutId = setTimeout(() => {
                dispatch(userAction(pendingData));
            }, state.retryTimeout);
        }

        if (!httpError) {
            clearTimeout(timeOutId);
            setState({ tryAttepmt: 0 });
            dispatch(setReconnectNotification({ active: false, tryAttepmt: 0, maxTries: state.maxTries }));
        }
    }, [pendingData, httpError]);
};
